export var OperatingSystem;
(function (OperatingSystem) {
    OperatingSystem["ANDROID"] = "ANDROID";
    OperatingSystem["IOS"] = "IOS";
    OperatingSystem["LINUX"] = "LINUX";
    OperatingSystem["MAC_OS"] = "MAC_OS";
    OperatingSystem["WINDOWS"] = "WINDOWS";
    OperatingSystem["WINDOWS_10"] = "WINDOWS_10";
    OperatingSystem["WINDOWS_11"] = "WINDOWS_11";
    OperatingSystem["WINDOWS_7"] = "WINDOWS_7";
    OperatingSystem["WINDOWS_8"] = "WINDOWS_8";
    OperatingSystem["WINDOWS_8_1"] = "WINDOWS_8.1";
    OperatingSystem["WINDOWS_VISTA"] = "WINDOWS_VISTA";
    OperatingSystem["WINDOWS_XP"] = "WINDOWS_XP";
})(OperatingSystem || (OperatingSystem = {}));
